import { render } from "./FlySwitch.vue?vue&type=template&id=5696a0b4"
import script from "./FlySwitch.vue?vue&type=script&lang=js"
export * from "./FlySwitch.vue?vue&type=script&lang=js"

import "./FlySwitch.vue?vue&type=style&index=0&id=5696a0b4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__